<template>
  <router-view />
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'DashboardFinance',
  })
</script>
